// ABOUTME: Selects the read-only job DTO returned by the job search endpoint.
// ABOUTME: Keeps ephemeral view fields separate from the persistable edit DTO.
export const getJobViewSearchBody = (jobId: string, companyId: unknown) => ({
    id: jobId,
    companyId,
    searchForEdit: true,
    includeViewData: true
});

interface IJobSearchData {
    mainData?: Compleo.IObject;
    viewData?: Compleo.IObject;
}

export const getJobViewData = (jobSearchData: IJobSearchData | undefined) =>
    jobSearchData?.viewData || jobSearchData?.mainData || {};
